export const pageOptions = {
  headerMinHeight: 180,
  segmentItemOffsets: 0,
};
